(() => {
  const OFFICIAL_EUR_BGN_RATE = 1.95583;
  const DUAL_DISPLAY_END = Date.parse('2026-08-09T00:00:00+03:00');
  const activeCurrency = window.Shopify?.currency?.active?.toUpperCase();
  let dualDisplayActive = Date.now() < DUAL_DISPLAY_END;
  const excludedSelector = [
    'script',
    'style',
    'noscript',
    'template',
    'textarea',
    'input',
    'select',
    'option',
    'svg',
    'code',
    'pre',
    '[data-mf-no-dual-price]',
    '[data-mf-dual-price]',
  ].join(',');
  const priceSpacingPattern = '[\\u00a0\\u202f \\t]*';
  const localizedAmountPattern = "[0-9](?:[0-9\\u00a0\\u202f \\t.,'’]*[0-9])?";
  const euroPricePattern = new RegExp(
    [
      `€${priceSpacingPattern}${localizedAmountPattern}(?:${priceSpacingPattern}EUR\\b)?`,
      `EUR\\b${priceSpacingPattern}€?${priceSpacingPattern}${localizedAmountPattern}(?:${priceSpacingPattern}€)?`,
      `${localizedAmountPattern}${priceSpacingPattern}€(?:${priceSpacingPattern}EUR\\b)?`,
      `${localizedAmountPattern}${priceSpacingPattern}EUR\\b`,
    ].join('|'),
    'gi',
  );
  const bgnFormatter = new Intl.NumberFormat('bg-BG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const parseLocalizedAmount = (value) => {
    let normalized = value
      .replace(/(?:EUR|€)/gi, '')
      .replace(/[\u00a0\u202f \t'’]/g, '');
    const commaIndex = normalized.lastIndexOf(',');
    const dotIndex = normalized.lastIndexOf('.');

    if (commaIndex !== -1 && dotIndex !== -1) {
      const decimalSeparator = commaIndex > dotIndex ? ',' : '.';
      const thousandsSeparator = decimalSeparator === ',' ? /\./g : /,/g;
      normalized = normalized.replace(thousandsSeparator, '').replace(decimalSeparator, '.');
    } else if (commaIndex !== -1 || dotIndex !== -1) {
      const separator = commaIndex !== -1 ? ',' : '.';
      const separatorIndex = normalized.lastIndexOf(separator);
      const decimalPlaces = normalized.length - separatorIndex - 1;

      if (decimalPlaces > 0 && decimalPlaces <= 2) {
        normalized = normalized.replace(separator, '.');
      } else {
        normalized = normalized.split(separator).join('');
      }
    }

    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : null;
  };

  const normalizePrimaryText = (value) => {
    if (!value.includes('€')) return value;

    return value.replace(/[\u00a0\u202f \t]*EUR\b[\u00a0\u202f \t]*/gi, ' ').trim();
  };

  const createDualPrice = (primaryText, euroAmount) => {
    const pair = document.createElement('span');
    const primary = document.createElement('span');
    const secondary = document.createElement('span');
    const bgnAmount = Math.round((euroAmount * OFFICIAL_EUR_BGN_RATE + Number.EPSILON) * 100) / 100;

    pair.className = 'mf-dual-price-pair';
    pair.dataset.mfDualPrice = '';
    primary.className = 'mf-dual-price-primary';
    secondary.className = 'mf-dual-price-secondary';
    primary.textContent = primaryText;
    secondary.textContent = ` (${bgnFormatter.format(bgnAmount)} лв.)`;
    pair.append(primary, secondary);

    return pair;
  };

  const processTextNode = (textNode) => {
    const parent = textNode.parentElement;
    const sourceText = textNode.nodeValue;

    if (!parent || !sourceText || !sourceText.match(/€|EUR/i) || parent.closest(excludedSelector)) return;

    const matches = Array.from(sourceText.matchAll(euroPricePattern));
    if (!matches.length) return;

    const fragment = document.createDocumentFragment();
    let cursor = 0;
    let replacements = 0;

    matches.forEach((match) => {
      const euroAmount = parseLocalizedAmount(match[0]);
      if (euroAmount === null) return;

      const primaryText = normalizePrimaryText(match[0]);
      if (!dualDisplayActive && primaryText === match[0]) return;

      fragment.append(document.createTextNode(sourceText.slice(cursor, match.index)));
      fragment.append(
        dualDisplayActive ? createDualPrice(primaryText, euroAmount) : document.createTextNode(primaryText),
      );
      cursor = match.index + match[0].length;
      replacements += 1;
    });

    if (!replacements) return;

    fragment.append(document.createTextNode(sourceText.slice(cursor)));
    textNode.replaceWith(fragment);
  };

  const processTree = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      processTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let currentNode;
    while ((currentNode = walker.nextNode())) textNodes.push(currentNode);
    textNodes.forEach(processTextNode);
  };

  const removeBgnPrices = () => {
    document.querySelectorAll('[data-mf-dual-price]').forEach((pair) => {
      const primary = pair.querySelector('.mf-dual-price-primary');
      pair.replaceWith(document.createTextNode(primary?.textContent ?? ''));
    });
  };

  if (activeCurrency && activeCurrency !== 'EUR') return;

  const start = () => {
    dualDisplayActive = Date.now() < DUAL_DISPLAY_END;
    if (!dualDisplayActive) removeBgnPrices();
    processTree(document.body);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'characterData') processTextNode(record.target);
        record.addedNodes.forEach(processTree);
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    if (dualDisplayActive) {
      const timeUntilEnd = DUAL_DISPLAY_END - Date.now();
      window.setTimeout(() => {
        dualDisplayActive = false;
        removeBgnPrices();
      }, Math.min(timeUntilEnd, 2147483647));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
